module.exports = __webpack_public_path__ + "static/media/hamburger.237ad94a.svg";